import React, {useEffect, useState} from "react";
import {makeStyles} from "@material-ui/core/styles";
import ExcelFile from "react-export-excel-fixed-xlsx/dist/ExcelPlugin/components/ExcelFile";
import ExcelSheet from "react-export-excel-fixed-xlsx/dist/ExcelPlugin/elements/ExcelSheet";
import ExcelColumn from "react-export-excel-fixed-xlsx/dist/ExcelPlugin/elements/ExcelColumn";
import {convertSecondsToMinutesSecondsFormat} from "../../../common/Util";
import {useSelector} from "react-redux";



const useStyles = makeStyles(theme => ({

}));

const ExportarTemposEtapasXLS = ({
                            dataSet
                     }) => {


    const classes = useStyles();
    const periodMin = useSelector(state => state.filter.periodMin);
    const periodMax = useSelector(state => state.filter.periodMax);

    console.log("entrou em DownloadFile");

    const headerSheet = [
        {
            descricao: `de ${periodMin} a ${periodMax}`
        },
        {
            descricao: `acesse a sheet DADOS ao lado, localizada na parte inferior.`
        }
    ];

    return(
        <React.Fragment>
            <ExcelFile filename="TemposPorEtapa">
                <ExcelSheet data={headerSheet} name="TemposPorMedidaCarcaca">
                    <ExcelColumn label="Tempos por Medida" value="descricao" />
                </ExcelSheet>
                <ExcelSheet data={dataSet} name="Dados">
                    <ExcelColumn label="Medida" value="medida"/>
                    <ExcelColumn label="# Etapa" value="sequencia"/>
                    <ExcelColumn label="Abrev" value="abreviatura"/>
                    <ExcelColumn label="Etapa" value="etapa"/>
                    <ExcelColumn label="Validade Min (hh)mm:ss"
                                 value={(d) => convertSecondsToMinutesSecondsFormat( (d.etapaValidaTempoMinimoSec * 1).toFixed())}/>
                    <ExcelColumn label="Validade Max (hh)mm:ss"
                                 value={(d) => convertSecondsToMinutesSecondsFormat( (d.etapaValidaTempoMaximoSec * 1).toFixed())}/>
                    <ExcelColumn label="Validade Min"
                                 value={(d) => convertSecondsToMinutesSecondsFormat( (d.etapaValidaTempoMinimoSec * 1).toFixed())}/>
                    <ExcelColumn label="Ciclos validos" value="abreviatura"/>
                    <ExcelColumn label="# Ciclos" value="valido"/>
                    <ExcelColumn label="Menor tempo"
                                 value={(d) => convertSecondsToMinutesSecondsFormat( (d.minTempoSec * 1).toFixed())}/>
                    <ExcelColumn label="Tempo Medio"
                                 value={(d) => convertSecondsToMinutesSecondsFormat( (d.avgTempoSec * 1).toFixed())}/>
                    <ExcelColumn label="Maior tempo"
                                 value={(d) => convertSecondsToMinutesSecondsFormat( (d.maxTempoSec * 1).toFixed())}/>
                    <ExcelColumn label="Menor tempo Sec"
                                 value={(d) => (d.minTempoSec * 1).toFixed()}/>
                    <ExcelColumn label="Tempo Medio Sec"
                                 value={(d) => (d.avgTempoSec * 1).toFixed()}/>
                    <ExcelColumn label="Maior tempo Sec"  style={{style: { alignment: { horizontal : "right" }} }}
                                 value={(d) => (d.maxTempoSec * 1).toFixed()}/>

                </ExcelSheet>
            </ExcelFile>
        </React.Fragment>
    );
}

export default ExportarTemposEtapasXLS;
